export default __webpack_public_path__ + "static/media/create-wine-image.b77f5316.jpeg";